// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
const MySwal = withReactContent(Swal)

// ** Axios Imports
import axios from 'axios'

export const getAll = createAsyncThunk('aircrafts/getAll', async () => {
  const response = await axios.get('/aircrafts')
  return response.data
})

export const addData = createAsyncThunk(
  'aircrafts/addData',
  async (document, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/aircrafts', document)
      await dispatch(getAll())
      return response.data
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // Mengambil pesan kesalahan dari respons JSON jika status kode 409
        const errorMessage = error.response.data
        return rejectWithValue(errorMessage)
      } else {
        throw error // Melanjutkan melempar kesalahan untuk penanganan umum
      }
    }
  }
)

export const updateData = createAsyncThunk(
  'aircrafts/updateData',
  async ({ data, id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.patch(`/aircrafts/${id}`, data)
      await dispatch(getAll())
      return response.data
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // Mengambil pesan kesalahan dari respons JSON jika status kode 409
        const errorMessage = error.response.data
        return rejectWithValue(errorMessage)
      } else {
        throw error // Melanjutkan melempar kesalahan untuk penanganan umum
      }
    }
  }
)

export const updateStatus = createAsyncThunk(
  'aircrafts/updateStatus',
  async ({ data, id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.patch(`/aircrafts/status/${id}`, data)
      await dispatch(getAll())
      return response.data
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // Mengambil pesan kesalahan dari respons JSON jika status kode 409
        const errorMessage = error.response.data
        return rejectWithValue(errorMessage)
      } else {
        throw error // Melanjutkan melempar kesalahan untuk penanganan umum
      }
    }
  }
)

export const deleteData = createAsyncThunk(
  'aircrafts/deleteData',
  async ({ id }, { dispatch }) => {
    const response = await axios.delete(`/aircrafts/${id}`)
    await dispatch(getAll())
    return response.data
  })

export const getFile = createAsyncThunk('aircrafts/getFile', async (file) => {
  const response = await axios.post(`/aircrafts/file`, file, { responseType: 'blob' })
  const fileData = response.data
  // Buat objek URL untuk file
  const fileUrl = URL.createObjectURL(fileData)
  return fileUrl
})

export const getAllMerk = createAsyncThunk('aircrafts/getAllMerk', async () => {
  const response = await axios.get('/merk')
  return response.data
})

export const getAllType = createAsyncThunk('aircrafts/getAllType', async () => {
  const response = await axios.get('/types')
  return response.data
})

export const getAllEngine = createAsyncThunk('aircrafts/getAllEngine', async () => {
  const response = await axios.get('/engine')
  return response.data
})

export const getAllCategory = createAsyncThunk('aircrafts/getAllCategory', async () => {
  const response = await axios.get('/category')
  return response.data
})

export const getAllDocument = createAsyncThunk('aircrafts/getAllDocument', async () => {
  const response = await axios.get('/documents')
  return response.data
})

export const dataSlice = createSlice({
  name: 'aircrafts',
  initialState: {
    results: [],
    file: null,
    result: null,
    selected: null,
    isLoading: false,
    merkOptions: [],
    typeOptions: [],
    engineOptions: [],
    categoryOptions: [],
    documentOptions: []
  },
  reducers: {
    selectData: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    },
    savePDF: (state, action) => {
      if (action.payload === null) {
        state.file = null
      } else {
        state.file = action.payload
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAll.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAll.fulfilled, (state, action) => {
        state.isLoading = false
        state.results = action.payload
      })
      .addCase(getAllMerk.pending, (state) => {
        state.merkOptions = []
        state.isLoading = true
      })
      .addCase(getAllMerk.fulfilled, (state, action) => {
        state.isLoading = false
        action.payload.map(item => {
          state.merkOptions.push({ value: item.id, label: item.name })
        })
      })
      .addCase(getAllType.pending, (state) => {
        state.typeOptions = []
        state.isLoading = true
      })
      .addCase(getAllType.fulfilled, (state, action) => {
        state.isLoading = false
        action.payload.map(item => {
          state.typeOptions.push({ value: item.id, label: item.name })
        })
      })
      .addCase(getAllEngine.pending, (state) => {
        state.engineOptions = []
        state.isLoading = true
      })
      .addCase(getAllEngine.fulfilled, (state, action) => {
        state.isLoading = false
        action.payload.map(item => {
          state.engineOptions.push({ value: item.id, label: item.name })
        })
      })
      .addCase(getAllCategory.pending, (state) => {
        state.categoryOptions = []
        state.isLoading = true
      })
      .addCase(getAllCategory.fulfilled, (state, action) => {
        state.isLoading = false
        action.payload.map(item => {
          state.categoryOptions.push({ value: item.id, label: item.name })
        })
      })
      .addCase(getAllDocument.pending, (state) => {
        state.documentOptions = []
        state.isLoading = true
      })
      .addCase(getAllDocument.fulfilled, (state, action) => {
        state.isLoading = false
        action.payload.map(item => {
          state.documentOptions.push({ value: item.id, label: item.name })
        })
      })
      .addCase(addData.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addData.rejected, (state, action) => {
        state.isLoading = false
        MySwal.fire({
          title: 'Failed!',
          html: `Add Data Failed <br> ${action.payload.msg}`,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
      .addCase(addData.fulfilled, (state) => {
        state.isLoading = false
        MySwal.fire({
          title: 'Success!',
          text: 'Added data successfully',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
      .addCase(updateData.rejected, () => {
        MySwal.fire({
          title: 'Failed!',
          text: 'Update Data failed',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
      .addCase(updateData.fulfilled, () => {
        MySwal.fire({
          title: 'Success!',
          text: 'Update Data Succcessfully',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
      .addCase(updateStatus.rejected, () => {
        MySwal.fire({
          title: 'Failed!',
          text: 'Update Data failed',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
      .addCase(deleteData.rejected, () => {
        MySwal.fire({
          title: 'Failed!',
          text: 'Delete data failed',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
      .addCase(deleteData.fulfilled, () => {
        MySwal.fire({
          title: 'Success!',
          text: 'Delete data Succcessfully',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary'
          },
          buttonsStyling: false
        })
      })
      .addCase(getFile.pending, (state) => {
        state.file = null
        state.isLoading = true
      })
      .addCase(getFile.fulfilled, (state, action) => {
        state.isLoading = false
        state.file = action.payload
      })
  }
})
export const { selectData, savePDF } = dataSlice.actions
export default dataSlice.reducer
